import { render, staticRenderFns } from "./groupFormModal.vue?vue&type=template&id=0451d014&scoped=true&"
import script from "./groupFormModal.vue?vue&type=script&lang=js&"
export * from "./groupFormModal.vue?vue&type=script&lang=js&"
import style0 from "./groupFormModal.vue?vue&type=style&index=0&id=0451d014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0451d014",
  null
  
)

export default component.exports